'use client'

import React, { useRef } from 'react';
import Image from 'next/image';
import Autoplay from 'embla-carousel-autoplay';

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '../ui/carousel';
import styles from './winnersHistoryCarousel.module.css';

function WinnerCard({ winner }) {
  return (
    <div className="card blog blog-primary shadow rounded border-0 overflow-hidden h-100 bg-white">
      <div className={`card-img bg-white ${styles.imageFrame}`}>
        <Image
          src={winner.image}
          width={720}
          height={1080}
          sizes="(max-width: 767px) 100vw, (max-width: 991px) 50vw, (max-width: 1399px) 33vw, 25vw"
          style={{ width: '100%', height: '100%', display: 'block', objectFit: 'contain' }}
          className="img-fluid"
          alt={winner.alt}
          draggable={false}
        />
      </div>
      <div className="card-body text-center">
        <h6 className="mb-1">Miss Plaja {winner.year}</h6>
        <p className="text-muted mb-0 small">Castigatoare Miss Plaja {winner.year}</p>
      </div>
    </div>
  );
}

export default function WinnersHistoryCarousel({ items }) {
  const autoplay = useRef(
    Autoplay({
      delay: 2800,
      stopOnInteraction: false,
      stopOnMouseEnter: true,
      stopOnFocusIn: true,
    }),
  );

  return (
    <>
      <div className={`d-md-none ${styles.mobileStack}`}>
        {items.map((winner) => (
          <div key={winner.id || winner.year}>
            <WinnerCard winner={winner} />
          </div>
        ))}
      </div>

      <div className="d-none d-md-block">
        <Carousel
          className={styles.carousel}
          opts={{ align: 'start', loop: true }}
          plugins={[autoplay.current]}
          onMouseLeave={() => autoplay.current.reset()}
        >
          <CarouselContent className={styles.track}>
            {items.map((winner) => (
              <CarouselItem className={styles.item} key={winner.id || winner.year}>
                <WinnerCard winner={winner} />
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious className={styles.button} />
          <CarouselNext className={styles.button} />
        </Carousel>
      </div>
    </>
  );
}
